import { render, staticRenderFns } from "./OgHelpTour.vue?vue&type=template&id=5a3fa8d4&scoped=true&"
import script from "./OgHelpTour.vue?vue&type=script&lang=js&"
export * from "./OgHelpTour.vue?vue&type=script&lang=js&"
import style0 from "./OgHelpTour.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OgHelpTour.vue?vue&type=style&index=1&id=5a3fa8d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3fa8d4",
  null
  
)

export default component.exports